import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4021756b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "form container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xs-12 margin-bottom-form-field" }
const _hoisted_5 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  class: "col-xs-12 margin-bottom-form-field",
  style: {"position":"relative"}
}
const _hoisted_8 = ["type"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_11 = { class: "error-text" }
const _hoisted_12 = { class: "submit" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
            class: _normalizeClass(`tb ${_ctx.errors.username.length ? 'error' : ''}`),
            type: "text",
            placeholder: "Korisničko ime ili email"
          }, null, 2), [
            [_vModelText, _ctx.form.username]
          ]),
          (_ctx.errors.username.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errors.username), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
            class: _normalizeClass(`tb ${_ctx.errors.password.length ? 'error' : ''}`),
            type: _ctx.isVisible ? 'text' : 'password',
            placeholder: "Lozinka"
          }, null, 10, _hoisted_8), [
            [_vModelDynamic, _ctx.form.password]
          ]),
          _createElementVNode("img", {
            src: _ctx.isVisible ? _ctx.eyeIcons.visible : _ctx.eyeIcons.hidden,
            class: "hidden-eye",
            style: _normalizeStyle(_ctx.changePasswordEyeStyle()),
            alt: "",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleVisibility && _ctx.handleVisibility(...args)))
          }, null, 12, _hoisted_9),
          (_ctx.errors.password.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.errors.password), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", {
          class: "forgot-password",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.forgotPassword()))
        }, "Zaboravljena lozinka?")
      ])
    ]),
    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.getLoginErrorMessage), 1),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        class: "btnSubmit",
        disabled: _ctx.isLoadingLogin,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleLogin()))
      }, _toDisplayString(_ctx.isLoadingLogin ? "Učitavanje..." : "Ulogujte se"), 9, _hoisted_13)
    ])
  ]))
}